import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "../hooks/useSessionStorage";
// import { process.env.REACT_APP_DASHBOARD_URL } from "./key";

interface PrivateRouteProps {
  children: React.ReactNode;
}

function PrivateRoute({ children }: PrivateRouteProps) {
  const navigate = useNavigate();
  const [authToken] = useSessionStorage("feemonk_data", "");

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    }

    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/auth`, {
      headers: {
        Authorization: `Bearer ${authToken.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.data) {
          navigate("/login");
        } else {
        }
      });
  }, [authToken.value, navigate, authToken]);

  return <>{children}</>;
}

export default PrivateRoute;
